import staticFooterURL from "@adapters/infrastructures/urlConfig/StaticFooterPages/staticFooter";
import MutualFundsConfigURL from "@adapters/infrastructures/urlConfig/Markets/mutualFundsURL";
import optionConfigURL from "@adapters/infrastructures/urlConfig/Markets/optionsURL";
import futuresConfigURL from "@adapters/infrastructures/urlConfig/Markets/futuresURL";
import equityConfigURL from "@adapters/infrastructures/urlConfig/Markets/equityURL";
export const avoidAuthToken = true;
export const nonAuthApiList = [
    equityConfigURL.marketToday,
    equityConfigURL.marketMap,
    equityConfigURL.sectorPerformance,
    equityConfigURL.topGainersLosers,
    equityConfigURL.indices,
    equityConfigURL.indicesViewAll,
    equityConfigURL.advanceDecline,
    equityConfigURL.advanceDeclineViewAll,
    equityConfigURL.outUnderPerformers,
    equityConfigURL.upperLowerCircuit,
    equityConfigURL.allTimeHighLow,
    equityConfigURL["52WeekHighLow"],
    equityConfigURL.priceBuzzer,
    equityConfigURL.indexPullersDraggers,
    equityConfigURL.stockSurveillance,
    equityConfigURL.fiiDii,
    equityConfigURL.understandingSection,
    equityConfigURL.ipos,
    futuresConfigURL.marketTodat,
    futuresConfigURL.mostActiveByVolumn,
    futuresConfigURL.highestOIGainersLosers,
    futuresConfigURL.topGainerLoser,
    futuresConfigURL.openInterest,
    futuresConfigURL.mostActiveByValue,
    futuresConfigURL.highestPremiumDiscount,
    futuresConfigURL.futuresSpot,
    futuresConfigURL.highestLowestRollovers,
    optionConfigURL.optionTable,
    optionConfigURL.highestOI,
    optionConfigURL.gainerLosers,
    optionConfigURL.highestVolume,
    optionConfigURL.understandingSection,
    MutualFundsConfigURL.getMutualFundsSchemes,
    MutualFundsConfigURL.fundsHouse,
    MutualFundsConfigURL.exploreFunds,
    staticFooterURL.exchangeHoldiday,
    staticFooterURL.circularUpdate,
    staticFooterURL.locateUsUrl,
];
